export default "__VITE_ASSET__CZa92u2o__"